import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

//import Home from './pages/root';
import { dashroutes } from './pages/dashboard/routes';
import { authroutes } from './pages/auth/routes';
import { createRouter } from './i2';
  
function FavComponent() {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/svg+xml';
    link.href = window.localStorage.getItem('favicon')||'/favicon.svg';

    // Remove existing favicons
    //const existingIcons = document.querySelectorAll("link[rel*='icon']");
    //existingIcons.forEach(icon => icon.parentNode.removeChild(icon));

    // Add the new one
    document.head.appendChild(link);

    return () => {
      // Cleanup on unmount
      document.head.removeChild(link);
    };
  }, []);
  return null;
  //return <div>Your component JSX</div>;
}
const AppRoot = () => {
  const [router, setRouter] = React.useState(null);
  let y = window.localStorage.getItem('baUid');
  let x = window.localStorage.getItem('account_verification');
  let i = { basename: window['basename'] };

  useEffect(() => {
    // This effect runs once on mount

  //i = {};
    if (y == null) {
    
      (async () => {
        try {
          const dr2 = await createRouter();
          
          //const k4dUrouter = createBrowserRouter([...dashroutes2], i);
          //setRouter(k4dUrouter);

          const k4dUrouter = createBrowserRouter([...authroutes], i);
          //console.log({ y, i, authroutes });
          setRouter(k4dUrouter);
           
        }catch(e) {
          //f(e);
        }
      })();  

    
  } else { 

      (async () => {
        try {
          const dashroutes2 = await createRouter();
          
          const k4dUrouter = createBrowserRouter([...dashroutes2], i);
          setRouter(k4dUrouter);
           
        }catch(e) {
          //f(e);
        }
      })();  
  }
  }, []);
  
  return router ? <>
    <FavComponent />
    <RouterProvider router={router} />
  </> : <div></div>;
   

}; 


/*
export default function HofA() {
  return (
    <>
      {' '}
      <LoaderProvider>
        <AppRoot />
        <ToastContainer />
      </LoaderProvider>
    </>
  );
}*/

export default function Bank1() {
  return (
    <>
      <AppRoot />
    </>
  );
}
